import React, { useEffect, useState } from "react"
import moment from "moment"
import {
  Box,
  Button,
  Grid,
  Typography,
  CircularProgress,
  Tooltip,
  Collapse,
} from "@mui/material"
import { FaChevronDown, FaChevronLeft, FaChevronUp } from "react-icons/fa6"
import * as Style from "./style"
import { useNavigate, useParams } from "react-router-dom"
import dummy from "../../images/dummy-image.jpg"
import { BsInfoCircleFill } from "react-icons/bs"

import {
  FormatChangeTime,
  FormatDate,
  FormatTime,
} from "../common/utctolocalDate"
import CenteredSpinner from "../common/CenteredSpinner"
import { LuPhone } from "react-icons/lu"
import { CiMail } from "react-icons/ci"
import { toast } from "react-toastify"
import { useAppliedPostMutation } from "../../features/Auth/authApi"
import { useGetspecificPostApiQuery } from "../../features/OverViewAuth/overViewApi"
import { useAppDispatch } from "../../app/store"
import { useAppSelector } from "../../app/hooks"
import { appliedPostKey } from "../../features/Auth/authSlice"
import PreviewImage from "../common/previewImage"
import ExtraDetailsDisplay from "../ExtraDetailsSeeker/ExtraDetailsDisplay"
const BookingServiceDetails = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [selectedImage, setSelectedImage] = useState<string | null>(null)
  const [showExtraDetails, setShowExtraDetails] = useState(false)
  const urlSearchParams = new URLSearchParams(window.location.search)
  const type = urlSearchParams.get("type")
  const dispatch = useAppDispatch()
  const openAppliedButton = useAppSelector(
    (state) => state?.auth.appliedPostKey,
  )
  const { data: appliedJob, isLoading } = useGetspecificPostApiQuery({
    postId: id,
  })

  const [
    appliedPostProvider,
    { data: postData, error, isLoading: postIsloading },
  ] = useAppliedPostMutation()

  const handleAppliedPost = () => {
    const payload = {
      postId: id,
    }
    appliedPostProvider(payload)
  }

  useEffect(() => {
    if (postData?.message) {
      toast.success(postData?.message, { autoClose: 1000 })

      dispatch(appliedPostKey("openAplledButton" as any))

      navigate("/dashboard/applied-job")
    } else {
      toast.error((error as any)?.data?.message, { autoClose: 1000 })
    }
  }, [postData, error])
  const handleNavigate = () => {
    if (type == "applied-job") {
      navigate("/dashboard")
    } else {
      navigate("/dashboard/jobs")
    }
  }

  useEffect(() => {
    if (openAppliedButton === "openAplledButton") {
      navigate("/dashboard/applied-job")
    }
  }, [openAppliedButton])

  const handleImageClick = (image: string) => {
    setSelectedImage(image)
  }

  const handleClosePreview = () => {
    setSelectedImage(null)
  }

  return (
    <>
      {isLoading ? (
        <CenteredSpinner />
      ) : (
        <>
          <Style.Overview>
            <Box
              className="d-flex my-3"
              justifyContent="space-between"
              alignItems="center"
              flexWrap="wrap"
            >
              <Box className="d-flex align-items-center gap-md-4 gap-2">
                <Button className="back-btn mb-0" onClick={handleNavigate}>
                  <FaChevronLeft />
                </Button>
                <Typography variant="h2" className=" mb-0">
                  Job Details
                </Typography>
              </Box>
              <Box display="flex">
                <Button
                  className="view-profile captalize applied-btn text-captalize me-0 me-md-4"
                  onClick={handleAppliedPost}
                >
                  {postIsloading ? (
                    <CircularProgress style={{ color: "pink" }} size={15} />
                  ) : (
                    "Apply"
                  )}
                </Button>
              </Box>
            </Box>
          </Style.Overview>
          <Box className="">
            <Style.Overview>
              <Box className="feature-card py-4 px-2" sx={{ minHeight: "500px" }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: {
                      xs: "column",
                      sm: "row",
                    },
                    gap: 2,
                    height: "100%",
                  }}
                >
                  {/* LEFT SIDE - 30% */}
                  <Box
                    sx={{
                      width: {
                        xs: "100%",
                        sm: "30%"
                      },
                      borderRight: {
                        xs: "none",
                        sm: "1px solid #e0e0e0"
                      },
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: 2,
                    }}
                  >
                    <Box className="mb-3">
                      <img
                        src={appliedJob?.data?.seekerData?.profilePic || dummy}
                        className="profile-img-2"
                      />
                    </Box>

                    <Typography
                      variant="body1"
                      className="mb-3 fw-bold d-flex align-items-center gap-1"
                    >
                      <CiMail color="#F475A4" />
                      <span
                        style={{
                          overflowWrap: "anywhere",
                          maxWidth: 180,
                          display: "inline-block",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {appliedJob?.data?.seekerData?.email?.slice(0, 16)}
                        {appliedJob?.data?.seekerData?.email &&
                          appliedJob.data.seekerData.email.length > 16
                          ? "..."
                          : ""}
                      </span>
                      <Tooltip
                        title={appliedJob?.data?.seekerData?.email}
                        arrow
                      >
                        <Button
                          style={{ minWidth: "10px" }}
                          className="m-0 p-0"
                        >
                          <BsInfoCircleFill color="#F475A4" />
                        </Button>
                      </Tooltip>
                    </Typography>

                    <Typography
                      variant="body1"
                      className="mb-3 fw-bold d-flex align-items-center gap-1"
                    >
                      <LuPhone color="#F475A4" />{" "}
                      {appliedJob?.data?.seekerData?.contactNo}
                    </Typography>
                  </Box>

                  {/* RIGHT SIDE - 70% */}
                  <Box
                    sx={{
                      width: {
                        xs: "100%",
                        sm: "70%"
                      },
                      overflowY: "auto",
                      paddingX: 2,
                      display: "flex",
                      flexDirection: "column",
                      gap: 2,
                    }}
                  >
                    {/* Reusable Field Component */}
                    {[
                      {
                        label: "Service Required",
                        value: appliedJob?.data?.service?.name,
                      },
                      {
                        label: "Number Of Provider Required",
                        value: appliedJob?.data?.personRequired,
                      },
                      // {
                      //   label: "Age Of Provider",
                      //   value: appliedJob?.data?.ageRange?.join(" - "),
                      // },
                      {
                        label: "Service Date",
                        value: appliedJob?.data?.from
                          ? moment
                            .utc(appliedJob.data.from)
                            .local()
                            .format("DD MMMM, dddd YYYY")
                          : "-",
                      },

                      {
                        label: "Service Time",
                        value: (
                          <Box
                            sx={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <FormatChangeTime
                              dateString={appliedJob?.data?.from}
                            />
                            <span>-</span>
                            <FormatChangeTime
                              dateString={appliedJob?.data?.till}
                            />
                          </Box>
                        ),
                      },
                      {
                        label: "Language",
                        value: appliedJob?.data?.language?.join(" "),
                      },
                      {
                        label: "Location",
                        value: appliedJob?.data?.location,
                      },
                      {
                        label: "Additional Instructions",
                        value: appliedJob?.data?.description,
                        hidden: !appliedJob?.data?.description,
                      },
                    ]
                      .filter((item) => !item.hidden)
                      .map((field, idx) => (
                        <Box
                          key={idx}
                          sx={{
                            border: "1px solid #e0e0e0",
                            borderRadius: "5px",
                            padding: 2,
                            backgroundColor: "#f9f9f9",
                          }}
                        >
                          <Typography variant="body2" className="fw-bold mb-1">
                            {field.label}
                          </Typography>
                          <Typography variant="body2">{field.value}</Typography>
                        </Box>
                      ))}

                    {/* Uploaded Images */}
                    {appliedJob?.data?.attachments?.length > 0 && (
                      <Box
                        sx={{
                          border: "1px solid #e0e0e0",
                          borderRadius: "5px",
                          padding: 2,
                          backgroundColor: "#f9f9f9",
                        }}
                      >
                        <Typography variant="body2" className="fw-bold mb-2">
                          Uploaded Photos
                        </Typography>
                        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                          {appliedJob?.data?.attachments.map(
                            (img: any, i: number) => (
                              <img
                                key={i}
                                src={img}
                                alt={`attachment-${i}`}
                                style={{
                                  height: "48px",
                                  width: "48px",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleImageClick(img)}
                              />
                            ),
                          )}
                        </Box>
                      </Box>
                    )}
                  </Box>
                </Box>

                {/* Additional Info Section - Below the service details container */}

                <Box className="py-2 px-0 bg-white my-2" sx={{ maxHeight: "500px", borderRadius: "18px" }}>
                  {appliedJob?.data?.extraDetails && (
                    <Box className="px-4 mt-2">
                      <Button
                        variant="outlined"
                        onClick={() => setShowExtraDetails(!showExtraDetails)}
                        className="text-capitalize d-flex align-items-center gap-2"
                        style={{
                          borderColor: "#F475A4",
                          color: "#F475A4",
                          fontWeight: "600",
                          padding: "8px 16px",
                        }}
                      >
                        {showExtraDetails ? (
                          <>
                            <FaChevronUp size={14} />
                            Hide Additional Information
                          </>
                        ) : (
                          <>
                            <FaChevronDown size={14} />
                            Show Additional Information
                          </>
                        )}
                      </Button>

                      <Collapse in={showExtraDetails}>
                        <Box className="mt-3 p-2 border rounded">
                          <ExtraDetailsDisplay
                            extraDetails={appliedJob?.data?.extraDetails}
                            serviceName={appliedJob?.data?.service?.name}
                          />
                        </Box>
                      </Collapse>
                    </Box>
                  )}
                  {/* </Box> */}
                </Box>
                {/* Preview Image Modal */}
                <PreviewImage
                  selectedImage={selectedImage}
                  handleClosePreview={handleClosePreview}
                />
              </Box>
            </Style.Overview>
          </Box>
        </>
      )}
    </>
  )
}
export default BookingServiceDetails
